export default __webpack_public_path__ + "static/media/insights.7286bab1.svg";